var render = function render(){var _vm=this,_c=_vm._self._c;return (['3.8','3.8_2'].includes(_vm.$store.state.config.ui_version))?_c('subgame3Dian8'):_c('subgame')
}
var staticRenderFns = []

export { render, staticRenderFns }